import React, { FC, useState } from "react";
import { FormControl } from "react-bootstrap";
import { SearchIcon } from "../../../../src/assets/images/svg/IconCollection";

interface ISearchInputProps {
    placeholder: string;
    value?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    isCollapsable?: boolean;
}

const SearchInput: FC<ISearchInputProps> = ({ placeholder, value, onChange, isCollapsable }) => {
    const [expandSearchBar, setExpandSearchBar] = useState(false);

    const expandSearchBarHandler = () => {
        if (isCollapsable) {
            setExpandSearchBar(!expandSearchBar);
        }
    };

    return (
        <div
            className={`search-input-wrapper ${
                !isCollapsable ? "border-none margin-0" : !expandSearchBar ? "show-wrapper" : "hide-wrapper"
            }`}
        >
            <div className="search-icon-wrapper" onClick={expandSearchBarHandler}>
                <SearchIcon height={14} width={14} />
            </div>
            <FormControl placeholder={placeholder} value={value} onChange={onChange} className="search-input" />
        </div>
    );
};

export default SearchInput;
